<div class="cnt-page-internal">
    <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)" style="width: 100%;"></teiasoft-toolbar>
    <div class="cnt-users-grid">
        <teiasoft-grid *ngIf="isLoaded" style="width:100%"
            [title]="'users'"
            [gridDescription]="'users.title' | translate"
            [columnsToHide]="columnsToHide"
            [columnsToShow]="columnsToShow"
            [dataSet]="usersForGrid"
            [showFooter]="false"
            [selectable]="false"
            [disableAllSelection]="true"
            [theme]="globals.theme!"
            [autoWidth]="true"
            [showEditIcon]="false"
            [minWidthVw]="minWidthVw"
            [dateFormat]="globals.dateFormat!"
            [dateTimeFormat]="globals.dateTimeFormat!"
            [customIcoCols]="customIcoCols" 
            (customIconClick)="customIconClick($event)"
            [filterable]="false"
            [gridName]="'users'"
            [fullFilter]="true"
            [openFilter]="openFilter"
            (imFiltering)="imFiltering($event)"
            [clearFilters]="clearFilters"
            [maxHeightVh]="70"
        ></teiasoft-grid> 
    </div>

</div>

<!-- CONFIRM  MODAL -->
<teiasoft-modal (onConfirmClick)="onConfirmModal($event)" [theme]="globals.theme!" [isMobile]="!globals.isDesktop!"></teiasoft-modal>

<!-- MODAL USER -->
<app-modal-user 
    *ngIf="showModalUser"
    [isMobile]="false" 
    [theme]="globals.theme!"
    (closeModalUser)="closeModalUser($event)"
    [action]="action"
    [authInfo]="authInfo"
    [groups]="groups"
    [userName]="userNameToEdit"
></app-modal-user><!-- (closeModalItem)="closeModalItem($event)" -->